export default "{\n    \"label\": \"Vencido\"\n}"